import type {
  ExtendedConstraints,
  EventHandlerCb,
  CapabilityConfig,
} from '../../../types';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'config-applet';

export enum Events {
  Update = 'config-applet:update',
}
export enum Actions {
  Save = 'config-applet:save',
  Get = 'config-applet:get',
  StateDirty = 'config-applet:state-dirty',
  StateReset = 'config-applet:state-reset',
}

export type Config = AppletSpec.Config & {
  type: typeof id;
};

export type ConfigObject = Record<string, unknown>;
export type UpdatePayload = ConfigObject | undefined;
export type SavePayload = ConfigObject;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  eventPayloadTuple: [Events.Update, UpdatePayload];
  eventHandlerTuple: [Events.Update, EventHandlerCb<UpdatePayload>];
  actionPayloadTuple:
    | [Actions.Get]
    | [Actions.Save, SavePayload]
    | [Actions.StateDirty]
    | [Actions.StateReset];
}>;

export function isValidConfig(config: CapabilityConfig): boolean {
  if (!AppletSpec.isValidConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
